var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page"},[_c('div',[_vm._v("PAGE NOT FOUND 404")]),_c('router-link',{staticClass:"btn-sub err-btn",attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t('ui.error_button')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }